import { call, put, takeEvery } from "redux-saga/effects"
import { getCustomizeColumnsOrderError, getCustomizeColumnsOrderSuccess, updateCustomizeColumnsOrderError, updateCustomizeColumnsOrderSuccess } from "./actions"
import { AppConfiguration } from "config";
import { genericGetRequest_2, genericPutRequest } from "helpers/sf_backend_helper";
import { GET_CUSTOMIZE_COLUMNS_ORDER, UPDATE_CUSTOMIZE_COLUMNS_ORDER } from "./actionTypes";

function* onGetCustomizeColumnsOrder(action) {
  const page_name = action?.payload?.page_name
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
        genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/customize_columns_order`,
      action?.payload,
      {
        "Authorization": user.token,
        "account-id": user.account_id,
        'Content-Type': 'application/json'
      }
    )
    yield put(getCustomizeColumnsOrderSuccess({page_name: page_name, column_order: response?.data}))
  } catch (error) {
    yield put(getCustomizeColumnsOrderError(error))
  }
}

function* onUpdateCustomizeColumnsOrder(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/customize_columns_order/${action.payload.page_name}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          'Authorization': user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
          'accept': 'application/json',
        }
      }
    )
    yield put(updateCustomizeColumnsOrderSuccess({page_name: action?.payload?.page_name, column_order: response}))
  } catch (error) {
    yield put(updateCustomizeColumnsOrderError(error))
  }
}

function* CustomizeColumnsOrderSaga() {
  yield takeEvery(GET_CUSTOMIZE_COLUMNS_ORDER, onGetCustomizeColumnsOrder);
  yield takeEvery(UPDATE_CUSTOMIZE_COLUMNS_ORDER, onUpdateCustomizeColumnsOrder);
}

export default CustomizeColumnsOrderSaga;
